var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundMyFundraises(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1680,
    height: 697,
    viewBox: "0 0 1680 697",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.848 424.917L102 504.5L-44 536.5V0H1682.5V697L1519.84 668.126C1515.66 667.383 1511.67 665.789 1508.13 663.442L1345.87 555.894C1342.98 553.978 1339.78 552.561 1336.43 551.701L1156.2 505.574C1153.41 504.861 1150.54 504.539 1147.67 504.617L895.951 511.434C894.319 511.478 892.687 511.393 891.069 511.18L678.208 483.185C674.761 482.732 671.414 481.701 668.308 480.137L537.454 414.243C534.504 412.757 531.335 411.753 528.067 411.267L399.899 392.228C396.654 391.746 393.352 391.782 390.118 392.335L229.278 419.841C224.814 420.604 220.571 422.337 216.848 424.917Z",
    fill: "url(#paint0_linear_668_18616)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_18616",
    x1: 819,
    y1: 589,
    x2: 819,
    y2: -167.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#528898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#486C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E3949"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundMyFundraises);
export default __webpack_public_path__ + "static/media/background_my_fundraises.b1e82121348225306ff5dcb59cec1e7b.svg";
export { ForwardRef as ReactComponent };